<template>
  <div class="multi-calendar">
    <single-calendar
      v-model="startDate"
      :min-max="minMax"
      :disabled="disabled"
      :disable-weekdays="disableWeekdays_from"
      :pop-over-direction="popOverDirection"
      class="start"
    />
    <span class="date-divide" />
    <single-calendar
      v-model="endDate"
      :min-max="minMax"
      :disabled="disabled"
      :disable-weekdays="disableWeekdays_to"
      :pop-over-direction="popOverDirection"
      class="end"
    />
  </div>
</template>

<script>
import SingleCalendar from '@/components/ui/SingleCalendar.vue'

export default {
  components: { SingleCalendar },
  props: {
    fromDate: null,
    toDate: null,
    limitMinDate: null,
    limitMaxDate: null,
    disabled: {
      type: Boolean,
      default: false
    },
    disableWeekdays_from: { type: Array, default: null },
    disableWeekdays_to: { type: Array, default: null },
    termMessage: null,
    termUnit: { type: String, default: 'M' }, // M:monthsOption, d:days, y:years
    maxTerm: null,
    disableTodayAfter: {
      type: Boolean,
      default: true
    },
    popOverDirection: {
      type: String,
      default: 'bottom-start'
    }
  },
  data() {
    return {
      startDate: null,
      endDate: null
    }
  },
  computed: {
    minMax() {
      return {
        // min: this.limitMinDate,
        // max:
        //   this.limitMaxDate === null ||
        //   (this.disableTodayAfter === true &&
        //     this.$moment(this.limitMaxDate).isAfter(new Date()))
        //     ? new Date()
        //     : this.limitMaxDate
      }
    }
  },
  watch: {
    fromDate: {
      handler(value) {
        this.startDate = value
      },
      immediate: true
    },
    toDate: {
      handler(value) {
        this.endDate = value
      },
      immediate: true
    },
    startDate() {
      if (!this.startDate || !this.endDate) {
        return
      }
      if (Date.parse(this.startDate) <= Date.parse(this.endDate)) {
        this.$emit('changeDate', this.startDate, this.endDate)
      } else {
        this.$message({
          type: 'error',
          message: 'Ngày bắt đầu không được lớn hơn ngày kết thúc.'
        })
        setTimeout(() => {
          this.startDate = null
          this.$emit('changeDate', this.startDate, this.endDate)
        }, 200)
      }
    },
    endDate() {
      if (!this.startDate || !this.endDate) {
        return
      }
      if (Date.parse(this.startDate) <= Date.parse(this.endDate)) {
        this.$emit('changeDate', this.startDate, this.endDate)
      } else {
        this.$message({
          type: 'error',
          message: 'Ngày kết thúc không được nhỏ hơn ngày bắt đầu.'
        })
        setTimeout(() => {
          this.endDate = null
          this.$emit('changeDate', this.startDate, this.endDate)
        }, 200)
      }
    }
  },
  mounted() {},
  methods: {
    onReset(startDate = null, endDate = null) {
      this.startDate = startDate
      this.endDate = endDate
    }
  }
}
</script>
